import { ACTIONS } from '../Constants';

const getInitialState = () => ({
    byLearningAssetId: {},
    bySectionItemId: {}
});

const makeAssetReviewItemState = (byLearningAssetId, bySectionItemId, assetReviewItem) => {
    if (byLearningAssetId[assetReviewItem.parentId]) {
        byLearningAssetId[assetReviewItem.parentId][assetReviewItem._id] = assetReviewItem;
    } else if (!(assetReviewItem.parentId in byLearningAssetId)) {
        byLearningAssetId[assetReviewItem.parentId] = {
            [assetReviewItem._id]: assetReviewItem
        };
    }

    if (assetReviewItem.sectionItemId) {
        if (bySectionItemId[assetReviewItem.sectionItemId]) {
            bySectionItemId[assetReviewItem.sectionItemId][assetReviewItem._id] = assetReviewItem;
        } else if (!(assetReviewItem.sectionItemId in bySectionItemId)) {
            bySectionItemId[assetReviewItem.sectionItemId] = {
                [assetReviewItem._id]: assetReviewItem
            };
        }
    }
};

export default (state = getInitialState(), action) => {
    let newByLearningAssetId;
    let newBySectionItemId;
    switch (action.type) {
        case ACTIONS.GET_MANY_ASSET_REVIEW_ITEMS: {
            const { assetReviewItems } = action.payload;
            newByLearningAssetId = { ...state.byLearningAssetId };
            newBySectionItemId = { ...state.bySectionItemId };
            assetReviewItems.forEach((item) => {
                makeAssetReviewItemState(newByLearningAssetId, newBySectionItemId, item);
            });

            return {
                ...state,
                byLearningAssetId: newByLearningAssetId,
                bySectionItemId: newBySectionItemId
            };
        }

        case ACTIONS.GET_ASSET_REVIEW_ITEM:
        case ACTIONS.PUT_ASSET_REVIEW_ITEM_SUCCESS:
        case ACTIONS.POST_ASSET_REVIEW_ITEM_SUCCESS: {
            const { assetReviewItem } = action.payload;
            newByLearningAssetId = { ...state.byLearningAssetId };
            newBySectionItemId = { ...state.bySectionItemId };
            makeAssetReviewItemState(newByLearningAssetId, newBySectionItemId, assetReviewItem);

            return {
                ...state,
                byLearningAssetId: newByLearningAssetId,
                bySectionItemId: newBySectionItemId
            };
        }

        case ACTIONS.PUT_MANY_ASSET_REVIEW_ITEM_SUCCESS: {
            const { assetReviewItems } = action.payload;
            newByLearningAssetId = { ...state.byLearningAssetId };
            newBySectionItemId = { ...state.bySectionItemId };

            assetReviewItems.forEach((assetReviewItem) => {
                makeAssetReviewItemState(newByLearningAssetId, newBySectionItemId, assetReviewItem);
            });

            return {
                ...state,
                byLearningAssetId: newByLearningAssetId,
                bySectionItemId: newBySectionItemId
            };
        }

        default:
            return state;
    }
};
